<template>
	<div class="card bg-base-100 shadow">
		<div class="card-body">
			<div class="flex flex-wrap items-center justify-between gap-3">
				<div class="flex items-center gap-3">
					<div class="card-title flex items-center gap-2 text-xl">
						{{ t('customGraph.list.title') }}
					</div>
					<span class="badge badge-neutral badge-sm" aria-label="graph-count">
						{{ graphCount }}
					</span>
				</div>
				<div class="flex w-full items-center gap-2 sm:w-auto sm:justify-end">
					<input
						type="search"
						class="input input-bordered input-sm w-full max-w-xs"
						:placeholder="t('customGraph.list.filterPlaceholder')"
						v-model.trim="filterQuery" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useGraphs } from './_useGraphs'

	const { t, filterQuery, graphCount } = useGraphs()
</script>
